import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ChiSiamo from './pages/ChiSiamo';
import Offerte from './pages/Offerte';
import Contattaci from './pages/Contattaci';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import CookiePolicy from './pages/legal/CookiePolicy';
import Conferma from './pages/Conferma';
import Grazie from './pages/Grazie';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';

const AppContent: React.FC = () => {
  const location = useLocation();
  const isSpecialPage = location.pathname === '/conferma' || 
                        location.pathname === '/conferma/' || 
                        location.pathname === '/grazie' || 
                        location.pathname === '/grazie/';

  return (
    <>
      <ScrollToTop />
      {isSpecialPage ? (
        // Pagine /conferma e /grazie senza header e footer standard
        <Routes>
          <Route path="/conferma" element={<Conferma />} />
          <Route path="/grazie" element={<Grazie />} />
        </Routes>
      ) : (
        // Tutte le altre pagine con layout normale
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/offerte" element={<Offerte />} />
              <Route path="/contattaci" element={<Contattaci />} />
              
              {/* Pagine legali */}
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
        </div>
      )}
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
